import React from 'react';
import '../../scss/color.scss';
import { useTranslation } from 'react-i18next';

/**
 * QR Color Component
 * @returns
 */
function Color({ qrValues, setQrValues }: any) {
      const {t} = useTranslation('qrCode')
  const colors = [
    {
      id: 1,
      label:t('qrCode'),
    },
    {
      id: 2,
      label:t('qrBackgroundColor'),
    },
    {
      id: 3,
      label:t('innerEyeColor'),
    },
    {
      id: 4,
      label:t('outerEyeColor'),
    },
  ];

  /**
   * Handling QR Code Colors
   * @param event
   */
  const handleColorChange = (event: any) => {
    const { name, value } = event.target;
    setQrValues((previous: any) => {
      return {
        ...previous,
        [name]: value,
      };
    });
  };

  return (
    <div className="color-wrapper">
      <div className="color">
        {colors.map((color) => (
          <div key={color.id} className="color-section">
            <div key={color.id}>{color.label}</div>
          </div>
        ))}
      </div>
      <div className="color-inputs">
        <input
          key={qrValues.id}
          type="color"
          onChange={handleColorChange}
          name="fgColor"
          value={qrValues.fgColor}
        />
        <input
          key={qrValues.id}
          type="color"
          onChange={handleColorChange}
          name="bgColor"
          value={qrValues.bgColor}
        />
        <input
          key={qrValues.id}
          type="color"
          onChange={handleColorChange}
          name="innerColor"
          value={qrValues.innerColor}
        />
        <input
          key={qrValues.id}
          type="color"
          onChange={handleColorChange}
          name="outerColor"
          value={qrValues.outerColor}
        />
      </div>
    </div>
  );
}

export default Color;
